import { formatNumber, formatDecimalPlus, formatDecimal } from 'Util';
import React, { useEffect, useState } from 'react';
import { checkAttentionStock, removeAttentionStock, addAttentionStock } from 'Request/login'

const EtfInfo = ({ data }) => {
  const [isLiked, setIsLiked] = useState(false);
  
    // 최초 마운트 시 관심 여부 확인
    useEffect(() => {
      if (data.user_id && data.TICKER) {
        checkAttentionStock(data.user_id, data.TICKER).then(res => {
          setIsLiked(res.attention);
        });
      }
    }, [data.user_id, data.TICKER]);
  
    const toggleLike = async () => {
      try {
        if (isLiked) {
          await removeAttentionStock(data.user_id, data.TICKER);
        } else {
          await addAttentionStock(data.user_id, data.TICKER, data.STK_TYP, data.CTR_TYP);
        }
        setIsLiked(!isLiked);
      } catch (e) {
        console.error('관심종목 토글 실패:', e);
      }
    };

  function renderingRate(prev, cur) {
    if (prev !== 0) {
      const rate = (cur/prev-1)*100;
      if (rate > 0) {
        return (
          <div className="rate up"><i>▲</i> {formatNumber(cur - prev)} ({formatDecimalPlus(rate, 2)}%)</div>
        )
      } else if (rate < 0) {
        return (
          <div className="rate down"><i>▼</i> {formatNumber(cur - prev)} ({formatDecimalPlus(rate, 2)}%)</div>
        )
      } else {
        return (
          <div className="rate">- (+0.00%)</div>
        )
      }
    }
  }

  function renderingUsRate(prev, cur) {
    if (prev !== 0) {
      const rate = (cur/prev-1)*100;
      if (rate > 0) {
        return (
          <div className="rate up"><i>▲</i> {formatDecimal(cur - prev, 2)} ({formatDecimalPlus(rate, 2)}%)</div>
        )
      } else if (rate < 0) {
        return (
          <div className="rate down"><i>▼</i> {formatDecimal(cur - prev, 2)} ({formatDecimalPlus(rate, 2)}%)</div>
        )
      } else {
        return (
          <div className="rate">- (+0.00%)</div>
        )
      }
    }
  }
  
  function renderingUpDown(data) {
    if (data) {
      const val = data.COMMENT;
      if (val === 1) {
        return (
          <div className="flex">
            <div className="text"><span className="txt_red">상승</span>하고 있습니다.</div>
          </div>
        )
      } else if (val === -1) {
        return (
          <div className="flex">
            <div className="text"><span className="txt_blue">하락</span>하고 있습니다.</div>  
          </div>
        )
      } else if (val === 0) {
        return (
          <div className="flex">
            <div className="text"><span className="txt_gray">횡보</span>하고 있습니다.</div>  
          </div>
        )
      }
    } else {
      return (
        <div className="flex">
          <div className="none">
            <div className="none_txt"><strong>학습</strong> 하고 있습니다.</div>
          </div>
        </div>
      )
    }
  }


  return (
    <div className="content1">
      <div className="info">
        { data && data.info &&
        <div className="flex">
          <div className="stock">ETF | {data.info.BASE_ASSET}</div>
          <div className="name">
            {data.TICKER_NAME} <span>({data.TICKER})</span>
            <img
              src={isLiked ? '/static/images/heart2.png' : '/static/images/heart1.png'}
              alt="관심종목"
              onClick={toggleLike}
              style={{
                width: 18,
                height: 18,
                marginLeft: 8,
                cursor: 'pointer',
                verticalAlign: 'middle'
              }}
            />
          </div>
        </div>
        }
        { data && data.CTR_TYP === 1 && data.siseInfo &&
        <div className="flex">
          <div className="price"><strong>{formatNumber(data.siseInfo.trdPrc)}</strong><em>원</em></div>
          {renderingRate(data.siseInfo.prevddClsprc, data.siseInfo.trdPrc)}
        </div>
        }
        { data && data.CTR_TYP === 2 &&
        <div className="flex">
          <div className="price"><em>$</em><strong>{formatDecimal(data.info.PRICE, 2)}</strong></div>
          {renderingUsRate(data.info.PREV_PRICE, data.info.PRICE)}
        </div>
        }
      </div>
      <div className="box">
        <ul>
          <li className="small">
            <div className="flex">
              <div className="icon"><img src="/static/images/main3_box2.png" alt="" /></div>
              <div className="name">투자매력도</div>
            </div>
            {data && renderingUpDown(data.att)}
          </li>
          <li className="small">
            <div className="flex">
              <div className="icon"><img src="/static/images/main3_box3.png" alt="" /></div>
              <div className="name">매매시그널</div>
            </div>
            {data && renderingUpDown(data.ts)}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default EtfInfo;
